export const OPERATION_TYPE_TRANSLATIONS = {
  sale: "venta",
  rental: "alquiler",
};

export const PROPERTY_TYPE_PLURAL = {
  atico: "aticos",
  bajo: "bajo",
  casa: "casas",
  duplex: "duplex",
  edificio: "edificios",
  garaje: "garajes",
  inmueble: "inmuebles",
  local: "locales",
  piso: "pisos",
  oficina: "oficinas",
  solar: "solares",
};
